export default __webpack_public_path__ + "static/media/node.js_color_1.a5ea22e1.png";